module.exports = __webpack_public_path__ + "static/img/erwei.1f55dbef.png";